import {TargetGroup as TargetGroupType} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/target_group.types';
import {TargetGroupSwitch} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/target_group_switch.types';
import {originClick} from '@aboutyou/legacy-tracking-sdk';
import {useHistory} from '@aboutyou/router';
import {useTrackOriginClick} from '@aboutyou/tracking';
import {
  COLORS,
  FONT_SIZES,
  FONT_WEIGHTS,
  UnstyledLinkLinaria,
} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';
import React, {FC} from 'react';
import {convertTargetGroupToGender} from '../../../shared-deprecated/useSelectedTargetGroup';
import {useTargetGroupIdentifier} from '../../../shared-deprecated/useTargetGroupIdentifier';

export const TargetGroup: FC<TargetGroupSwitch> = ({targetGroups, tracker}) => {
  const selectedTargetGroup = useTargetGroupIdentifier();
  const trackOriginClick = useTrackOriginClick()(tracker.name as originClick);
  const history = useHistory();

  const onGenderClick =
    (targetGroup: TargetGroupType) => (e: React.SyntheticEvent) => {
      e.preventDefault();

      const gender = convertTargetGroupToGender(targetGroup);

      trackOriginClick();

      const searchParams = new URLSearchParams(history.location.search);
      if (gender) {
        searchParams.set('gender', gender);

        history.push({
          search: searchParams.toString(),
        });
      }
    };

  return (
    <Section data-testid="genderSwitch">
      {targetGroups.map(({link, targetGroup}) => (
        <Gender
          key={targetGroup}
          to={link.linkTarget.url}
          onClick={onGenderClick(targetGroup)}
          data-active={targetGroup === selectedTargetGroup}
        >
          {link.label}
        </Gender>
      ))}
    </Section>
  );
};

const Section = styled.section`
  border-bottom: 1px solid ${COLORS['Outline.Grey']};
  display: flex;
  justify-content: center;
  height: 32px;
  box-sizing: border-box;
`;

const Gender = styled(UnstyledLinkLinaria)`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 9px;
  min-width: 52px;
  box-sizing: content-box;
  color: ${COLORS['Text.Grey']};
  font-size: ${FONT_SIZES.px12};
  font-weight: ${FONT_WEIGHTS.mediumHeavy};
  line-height: 18px;
  transition: color 0.5s;
  letter-spacing: 0.48px;
  text-decoration: none;
  text-transform: uppercase;

  &::after {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    bottom: -1px;
    margin: auto;
    width: 24px;
    height: 2px;
    background: ${COLORS['Fill.Black']};
    transform: scale(0);
    transition: transform 0.5s ease;
  }

  &[data-active='true'] {
    color: ${COLORS['Text.Black']};
    font-weight: ${FONT_WEIGHTS.heavy};

    &::after {
      transform: scale(1);
      background: ${COLORS['Fill.Black']};
    }
  }

  &:hover {
    color: ${COLORS['Text.Black']};
  }
`;
